// ============================================================================
// ChatMentionSuggest.tsx — список автодополнения «@» над полем ввода чата.
// Только отображение и клик: состояние и клавиатура — useMentionSuggest.
// Клик по элементу НЕ забирает фокус у поля (onMouseDown → preventDefault) —
// ввод продолжается с места вставки «@login ».
// ============================================================================

import type { MentionCandidate } from '@/lib/mentions';

interface ChatMentionSuggestProps {
  items: MentionCandidate[];
  activeIndex: number;
  query: string;
  onHover: (index: number) => void;
  onPick: (item: MentionCandidate) => void;
}

export function ChatMentionSuggest({ items, activeIndex, query, onHover, onPick }: ChatMentionSuggestProps) {
  return (
    <div
      className="absolute bottom-full left-0 mb-1 w-full min-w-[220px] max-h-64 overflow-auto rounded-xl border bg-popover shadow-lg z-30"
      style={{ borderColor: 'var(--color-border)' }}
      onMouseDown={(e) => e.preventDefault()}
      role="listbox"
      aria-label="Упоминание участника"
    >
      <div
        className="px-2.5 py-1 text-[10px] uppercase tracking-wide text-muted-foreground border-b sticky top-0 bg-popover"
        style={{ borderColor: 'var(--color-border)' }}
      >
        {query ? `Участники · «${query}»` : 'Участники'}
      </div>
      {items.length === 0 && (
        <div className="px-2.5 py-2 text-[11px] text-muted-foreground italic">Никого не найдено</div>
      )}
      {items.map((it, i) => (
        <button
          key={it.id}
          type="button"
          role="option"
          aria-selected={i === activeIndex}
          className={`w-full text-left px-2.5 py-1.5 flex items-center gap-2 text-[12px] transition-colors ${i === activeIndex ? 'bg-accent' : 'hover:bg-muted/40'}`}
          onMouseEnter={() => onHover(i)}
          onClick={() => onPick(it)}
        >
          <span className="font-medium truncate">{it.name}</span>
          <span className="text-[11px] text-muted-foreground truncate ml-auto">@{it.login}</span>
        </button>
      ))}
    </div>
  );
}
